import React from 'react';  
import Layout from '../../components/UI/Layout/Layout'

function Profile() {
  return <Layout>
      Profile
  </Layout> ;
}

export default Profile;
